<template>
  <div class="container mainContent">
    <h2>AIDSImpact 2017 Committee</h2>

    <h3>Local Committee</h3>
    <ul>
      <li>Mark Tomlinson</li>
      <li>Sarah Skeen</li>
      <li>Bridgette Prince – HSRC</li>
      <li>Heidi van Rooyen – HSRC</li>
      <li>Connie Kganakga – SANAC</li>
      <li>Lifutso Motsieola – SANAC</li>
      <li>Chris Colvin – UCT</li>
      <li>Gita Ramjee</li>
      <li>Wendee Wechsberg</li>
      <li>Geoffrey Setswe – HSRC</li>
      <li>Di Cooper – UWC</li>
    </ul>

    <h3>International Board</h3>
    <ul>
      <li>Dr Jose Catalan</li>
      <li>Dr Barbara Hedge</li>
      <li>Prof Lorraine Sherr</li>
      <li>Prof Lucie Cluver</li>
      <li>Dr Richard Harding</li>
      <li>Bridgette Prince – HSRC</li>
      <li>Dr Bruno Spire</li>
      <li>Dr Udi Davidovich</li>
    </ul>

    <h3>Logistics</h3>
    <ul>
      <li>Maria Oud</li>
      <li>Yoni Sherr</li>
      <li>Jacob Taylor</li>
    </ul>

    <h3>International Scientific Advisory Board</h3>
    TBC

  </div>

</template>

<script>
  export default {
    name: "info_2017committee"
  }
</script>



/** WEBPACK FOOTER **
 ** info_2017committee.vue?6f1a4d38
 **/